import { render, staticRenderFns } from "./FormDownloadButton.vue?vue&type=template&id=8e767fd8"
import script from "./FormDownloadButton.vue?vue&type=script&lang=ts"
export * from "./FormDownloadButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports